var map = {
	"./app-google-da-DK.svg": 76823,
	"./app-google-de-DE.svg": 64357,
	"./app-google-en-GB.svg": 52391,
	"./app-google-en-US.svg": 29616,
	"./app-google-es-ES.svg": 85895,
	"./app-google-es-MX.svg": 69556,
	"./app-google-fr-FR.svg": 22811,
	"./app-google-it-IT.svg": 21197,
	"./app-google-nb-NO.svg": 88662,
	"./app-google-nl-NL.svg": 65619,
	"./app-google-pl-PL.svg": 95799,
	"./app-google-pt-BR.svg": 48087,
	"./app-google-pt-PT.svg": 92007,
	"./app-google-sv-SE.svg": 5110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53117;